import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { WmsToggleComponent } from "@wms/components";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BaseComponent, IWMSStandaloneEditorConstructionOptions, WMSEditorComponent } from '@wms/app/components';


@Component({
  selector: 'wms-test',
  standalone: true,
  imports: [CommonModule, FormsModule, WmsToggleComponent, TooltipModule, WMSEditorComponent],
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.less']
})
export class TestComponent extends BaseComponent {

  @Input() ws: any;
  @Input() testDisabled: boolean;
  @Input() disableDialogActions:boolean;
  @Output() testRun: EventEmitter<any> = new EventEmitter();
  @Output() urlChange: EventEmitter<any> = new EventEmitter();

  @ViewChild("codeEditor") wmsEditorEl: WMSEditorComponent;

  
  editorOptions: IWMSStandaloneEditorConstructionOptions = {
    value: "",
  };

  constructor() {
    super();
  }

  test(){
    this.testRun.emit()
  }
  /**
    * handles URL change
    * if url starts with ws:// and studio is loaded over https, throws an error
    */
  onUrlChange(url:any){
      this.urlChange.emit(url);
  }

  showResult(value:any){
    this.wmsEditorEl?.setEditorValue(value || "")
  }

  isTesting(event:any){
    this.ws.testNotRequired = event
  }

}
